import React, { useMemo } from "react";
import { Grid, Input, Popup, Icon, SemanticICONS } from "semantic-ui-react";
import { FormInputFieldProps } from "../../types";

const FormInputField: React.FC<FormInputFieldProps> = ({
  inputKey,
  title,
  value,
  isRequired,
  errorMessage,
  inputType,
  onChange,
  disabled,
  pattern,
  description,
}) => {
  const handleChange = useMemo(() => onChange(inputKey), [onChange, inputKey]);

  return (
    <Grid>
      <Grid.Row key={inputKey}>
        <Grid.Column textAlign="left" width={8} className="flex vcenter">
          <h5>
            {title || inputKey}
            {description && (
              <Popup
                content={description}
                trigger={
                  <Icon
                    name="info circle"
                    size="small"
                    style={{ marginLeft: "0.5em", cursor: "pointer" }}
                  />
                }
              />
            )}
            {isRequired && (
              <span className="color-red padding-left-half bold">*</span>
            )}
          </h5>
        </Grid.Column>
        <Grid.Column textAlign="left" width={8}>
          <Input
            className={`select-box full ${errorMessage ? "error-form-item" : ""}`}
            type={inputType}
            value={value || ""}
            onChange={handleChange}
            disabled={disabled}
            pattern={pattern}
            error={!!errorMessage}
          />
        </Grid.Column>
      </Grid.Row>
      {errorMessage && (
        <Grid.Row
          key={`${inputKey}-error`}
          className="padding-top-00 padding-bottom-20"
        >
          <Grid.Column textAlign="left" width={8}></Grid.Column>
          <Grid.Column textAlign="left" width={8}>
            {Array.isArray(errorMessage) ? (
              errorMessage.map((msg, index) => (
                <p key={index} className="color-orange padding-bottom-00">
                  <Icon
                    name={"circle times" as SemanticICONS}
                    className="margin-right-half"
                  />
                  <span className="font-S">{msg}</span>
                </p>
              ))
            ) : (
              <p className="color-orange padding-bottom-00">
                <Icon
                  name={"circle times" as SemanticICONS}
                  className="margin-right-half"
                />
                <span className="font-S">{errorMessage}</span>
              </p>
            )}
          </Grid.Column>
        </Grid.Row>
      )}
    </Grid>
  );
};

export default FormInputField;
